import {AfterViewInit, Component, HostListener, OnInit, ViewChild} from '@angular/core';

import { BaseService } from '../../../services/base.service';
import { AuthService } from '../../../services/auth.service';
import * as moment from 'moment';
import { SERVER_DATE_FORMAT_WITH_TIME, SERVER_DATE_FORMAT_WITHOUT_TIME } from '../../../config/date_format';
import { ActivatedRoute } from '@angular/router';
import { ReplaySubject, Subject } from 'rxjs';
import { User } from '../../../models/user';
import { TrackingLocation } from '../../../models/tracking-location';
import swal from 'sweetalert2';
import { FormControl } from '@angular/forms';
import {takeUntil, tap} from 'rxjs/internal/operators';
import { Market } from '../../../models/market';
import { MarketLevel } from '../../../models/market-level';
import {MatPaginator, MatSelectChange, MatSort, MatTabChangeEvent} from '@angular/material';
import {Title} from '@angular/platform-browser';
import {BaseDatasourceService} from '../../../services/base-datasource.service';
import {UserTimeline} from '../../../models/user-timeline';
import {Endpoints} from '../../../config/endpoints';
import {NoticeSeenReport} from '../../../models/notice-seen-report';
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from 'exceljs';
import * as fs from 'file-saver';
import {DatePipe} from '@angular/common';
import { TitleBroadcastService } from 'app/services/title-broadcast.service';

@Component( {
    selector   : 'app-location-list',
    templateUrl: './location-list.component.html',
    styleUrls  : [ './location-list.component.scss' ]
} )
export class LocationListComponent implements OnInit, AfterViewInit {

    constructor( private route: ActivatedRoute, private service: BaseService, private auth: AuthService, private titleService: Title, private titleBroadcastService: TitleBroadcastService  ) {
        this._unsubscribeAll = new Subject();
        this.titleBroadcastService.title.next('Tracking');
        this.loggedUser = auth.user;
        this.marketLevels = this.loggedUser.MarketLevelHierarchy;
        this.marketLevels.forEach( marketLevel => {
            this.markets[ marketLevel.Rank ] = [];
            this.selectedMarket[ marketLevel.Rank ] = null;
        } );
    }

    lat = 23.8383283;
    lng = 90.3759853;

    loggedUser: User;
    userList: User[] = [];
    filteredUserList: ReplaySubject<User[]> = new ReplaySubject<User[]>( 1 );
    userFilter: FormControl = new FormControl();
    locationList: TrackingLocation[] = [];
    timelineList: UserTimeline[] = [];
    loadingData = false;
    markets = [];
    selectedMarket: Market[] = [];
    marketLevels: MarketLevel[] = [];
    viewInOldFormat = false;
    displayedColumns = ['SN', 'From', 'To', 'Address', 'Duration', 'Distance', 'Interval'];

    market = new Market();
    user = new User();
    headers = [];
    headerValues = [];
    exportData = [];
    progress: number;
    showProgressBar = false;
    waitForProgress = true;
    totalPages = 0;
    datePipe = new DatePipe('en-US');
    selectedTab = 'map';

    @ViewChild( MatPaginator ) paginator: MatPaginator;
    @ViewChild( MatSort ) sort: MatSort;

    dataSource: BaseDatasourceService<UserTimeline>;

    filters = {
        'UserId'      : null,
        'Date'        : moment().format( SERVER_DATE_FORMAT_WITHOUT_TIME ),
        'FromDateTime': moment().format( SERVER_DATE_FORMAT_WITH_TIME ),
        'ToDateTime'  : moment().format( SERVER_DATE_FORMAT_WITH_TIME )
    };


    userType = 'ORGANIZATION_USER';

    private _unsubscribeAll: Subject<any>;

    // tslint:disable-next-line:typedef
    @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            this.getLocationList();
        }
    }

    ngOnInit(): void {

        this.titleService.setTitle('Tracking');

        this.service.getOrganizationSettings(this.loggedUser.Organization.Id).subscribe(pOrganizationSettings => {
            pOrganizationSettings.forEach(pModule => {
                if (pModule.ModuleName === 'LOCATION') {
                    pModule.ModularSettings.forEach(pSettings => {
                        if (pSettings.SettingsName === 'VIEW_ALL_POINTS_IN_LOCATION_TRACKING') {
                            this.viewInOldFormat = pSettings.SettingsValue === 'true';
                        }
                    });
                }
            });
        });

        this._getUserList();
        this.userFilter.valueChanges.pipe( takeUntil( this._unsubscribeAll ) ).subscribe( () => {
            if ( !this.userList ) {
                return;
            }

            const search = this.userFilter.value;
            if ( !search ) {
                this.filteredUserList.next( this.userList.slice() );
                return;
            }

            this._getUserList(search);
            this.filteredUserList.next( this.userList.filter( user => user.UserName.toLowerCase().indexOf( search.toLowerCase() ) > -1
                ) );
        } );
        this.dataSource = new BaseDatasourceService<UserTimeline>( this.service );
    }

    ngAfterViewInit(): void {
        this.service.getMarketList( {
            MarketLevelId: this.marketLevels[ 0 ].Id,
            Active       : true
        } ).subscribe( marketListResponse => {
            this.markets[ 1 ] = marketListResponse;
        } );
    }

    _getUserList(search?: string): void {
        let marketIdList = null;
        for ( let i = this.selectedMarket.length - 1; i >= 0; i-- ) {
            if ( this.selectedMarket[ i ] ) {
                marketIdList = [ this.selectedMarket[ i ].Id ];
                break;
            }
        }

        this.service.getUserList( {
            ResponseSize: 'MINIFY',
            UserType: this.userType,
            MarketIdList: marketIdList,
            SearchKey: search,
            PageNumber: 0,
            RecordsPerPage: 50
        } ).subscribe( userList => {
            this.userList = userList;
            this.filteredUserList.next( this.userList.slice() );
        } );
    }

    setDateRange( event ): void {
        const eventDate = moment( event.value );
        eventDate.set( 'hour', 0 );
        eventDate.set( 'minute', 0 );
        eventDate.set( 'second', 0 );
        this.filters.FromDateTime = moment( eventDate ).format( SERVER_DATE_FORMAT_WITH_TIME );
        eventDate.set( 'hour', 23 );
        eventDate.set( 'minute', 59 );
        eventDate.set( 'second', 59 );
        this.filters.ToDateTime = moment( eventDate ).format( SERVER_DATE_FORMAT_WITH_TIME );
        this.filters.Date = moment( eventDate ).format( SERVER_DATE_FORMAT_WITHOUT_TIME );
    }

    _resetChildDropdowns( pParentRank: number ): void {
        this.marketLevels.forEach( marketLevel => {
            if ( marketLevel.Rank > pParentRank ) {
                this.selectedMarket[ marketLevel.Rank ] = null;
                this.markets[ marketLevel.Rank ] = [];
            }
        } );
    }

    populateChildrenMarkets( event: MatSelectChange ): void {
        const market: Market = event.value;
        if ( market ) {
            this._resetChildDropdowns( market.MarketRank );
            if ( this.marketLevels[ market.MarketRank ] ) {
                this.service.getMarketList( {
                    MarketLevelId : this.marketLevels[ market.MarketRank ].Id,
                    ParentMarketId: market.Id,
                    Active        : true
                } ).subscribe( marketListResponse => {
                    this.markets[ market.MarketRank + 1 ] = marketListResponse;
                } );
            }
        }
        else {
            this._resetChildDropdowns( parseInt( event.source.id.slice( 6 ), 10 ) );
        }
        this._getUserList();

    }

    getLocationList(): void {
        if ( !this.filters.UserId ) {
            swal( 'Error!', 'Please select a user', 'error' );
            return;
        }

        this.loadingData = true;
        if (this.viewInOldFormat){
            this.service.getUserLocationList( this.filters ).subscribe( locationList => {
                this.loadingData = false;
                if ( locationList.length > 0 ) {
                    this.lat = locationList[ 0 ].Latitude;
                    this.lng = locationList[ 0 ].Longitude;
                }

                this.locationList = locationList;
            }, error => {
                this.loadingData = false;
            } );
        }
        else {
            this.service.getUserLocationTimeLine( this.filters ).subscribe( locationList => {
                this.loadingData = false;
                if ( locationList.length > 0 ) {
                    this.lat = locationList[ 0 ].Lat;
                    this.lng = locationList[ 0 ].Lon;
                }

                this.timelineList = locationList;
            }, error => {
                this.loadingData = false;
            } );
        }

    }

    tabChangeListener(pEvent: MatTabChangeEvent): void {
        if (pEvent.index == 0){
            this.selectedTab = 'map';
            if (this.filters.UserId){
                this.getLocationList();
            }
        }
        else {
            this.selectedTab = 'timeline';
            if (this.filters.UserId){
                this.reloadDatatable();
            }

        }
    }

    userChangeListener(pEvent: MatSelectChange): void {
        if (pEvent.value){
            this.filters.UserId = pEvent.value.Id;
        }
        else {
            this.filters.UserId = null;
            this.user = new User();
        }
    }

    reloadDatatable(): void {
        if (!this.filters.UserId){
            swal('Wrong Input', 'Please select a user', 'warning');
            return;
        }
        this.dataSource.fetchRemoteData( Endpoints.user_timeline, this.filters );
    }

    prepareData(pItemList: UserTimeline[]): void{
        let sn = 1;
        pItemList.forEach( pItem => {
            const array = [];
            array.push(sn);
            array.push(this.datePipe.transform(pItem.FromTime, 'h:mm:ss a'));
            array.push(this.datePipe.transform(pItem.ToTime, 'h:mm:ss a'));
            array.push(pItem.Duration ? pItem.Duration : 'Travelling');
            array.push(pItem.Lat);
            array.push(pItem.Lon);
            array.push(pItem.Address);
            array.push(pItem.DistanceInKm);
            array.push(pItem.Interval);
            array.push();
            this.exportData.push(array);
            sn += 1;
        });
    }

    prepareHeaders(): void {
        this.headers = [];
        this.headerValues = [];
        this.headers.push('Date');
        this.headerValues.push(this.filters.Date);

        if (this.filters.UserId){
            this.headers.push('User');
            this.headerValues.push(this.user.UserName + '(' + this.user.UserCode + ')');
        }

        if (this.market.Id){
            this.headers.push('Market');
            this.headerValues.push(this.market.MarketName + '(' + this.market.MarketCode + ')');
        }

    }

    downloadReport(): void {

        let isSelected1: boolean;
        let isSelected: boolean;
        let fileType: string;
        let fileName = null;

        this.market = new Market();
        this.market.Id = null;
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                this.market = this.selectedMarket[i];
                break;
            }
        }
        swal( {
            title: 'Download Report',
            html: '<div class="example-container"><mat-form-field style="border: 1px solid black;"><input matInput id="report" placeholder="Enter report name"' +
                '></mat-form-field><br><br>' +
                '<div class="container">\n' +
                '<div class="col-md-12">' +
                '<input class="col-xs-3" type="radio" value="CSV" id="input1" name="filetype" checked> CSV' +
                '<input class="col-xs-4 col-xs-offset-4" name="filetype" type="radio" value="XLSX" id="input2" style="margin-left: 20px;"> XLSX ' +
                '</div>\n' +
                '</div><div>',
            focusConfirm: false,
            showCancelButton   : true,
            confirmButtonText  : 'Download',
            showLoaderOnConfirm: true,
            preConfirm: () => {
                swal.disableConfirmButton();
                isSelected = (<HTMLInputElement>document.getElementById('input1')).checked;

                isSelected1 = (<HTMLInputElement>document.getElementById('input2')).checked;
                if (isSelected || isSelected1) {
                    swal.enableConfirmButton();
                    this.showProgressBar = true;
                } else {
                    swal.disableConfirmButton();
                }
                fileName = (<HTMLInputElement>document.getElementById('report')).value;
                if (isSelected) {
                    fileType = (<HTMLInputElement>document.getElementById('input1')).value;
                } else if (isSelected1) {
                    fileType = (<HTMLInputElement>document.getElementById('input2')).value;
                }


                const workbook: ExcelProper.Workbook = new Excel.Workbook();
                const worksheet = workbook.addWorksheet('Timeline');
                worksheet.addRow(['User Location Timeline']);
                worksheet.addRow([]);

                this.prepareHeaders();
                worksheet.addRow(this.headers);
                worksheet.addRow(this.headerValues);
                worksheet.addRow([]);

                const headers = [];
                headers.push('SN', 'Start Time', 'End Time', 'Duration', 'Latitude', 'Longitude', 'Address', 'Distance(Km)', 'Interval');

                worksheet.addRow(headers);
                this.exportData = [];

                let itemList = [];
                this.service.postData(Endpoints.user_timeline, this.filters).subscribe( pResponse => {
                    itemList = pResponse['Data']['content'];
                    this.showProgressBar = false;
                    if (itemList) {
                        this.prepareData(itemList);
                    }

                    if (this.exportData.length > 0) {
                        this.exportData.forEach(pExport => {
                            worksheet.addRow(pExport).alignment = {wrapText: true};
                        });

                        if (!fileName) {
                            fileName = 'User Location Timeline';
                        }
                        if (fileType == 'XLSX') {
                            workbook.xlsx.writeBuffer().then((data) => {
                                const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                                fs.saveAs(blob, fileName + '.xlsx');

                            });
                        }

                        if (fileType == 'CSV') {
                            workbook.csv.writeBuffer().then((data) => {
                                const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                                fs.saveAs(blob, fileName + '.csv');

                            });
                        }

                    } else {
                        swal('Message', 'No Data In This Range To Download');
                    }

                });
            },

            allowOutsideClick  : () => !swal.isLoading()
        } );

    }
}
